import { getAuthAxiosBackend } from "../../helpers/axios"

class StudentServices{

    get(id){
        return getAuthAxiosBackend().get('scholar-ships/students/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('scholar-ships/students', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('scholar-ships/students/' + id)
    }

    updateStatus(data = {}){
        return getAuthAxiosBackend().put('scholar-ships/students/' + data.id.toString(), data)
    }
}

export default new StudentServices()